import '../../../rubberduck/dist/js/import-jquery-light.js';
import { LazyLoad } from '../../../rubberduck/dist/lib/rubberduck/LazyLoad.js';
import { backgroundSetter } from '../../../rubberduck/dist/lib/rubberduck/backgroundSetter/backgroundSetter.js';
import { EventCalendarHandler } from '../../../../app/src/rubberduck/event/src/Event/dist/js/EventCalendarHandler.js';
import { GDPRHandler } from '../../../../app/src/rubberduck/core/src/GDPR/dist/js/GDPRHandler.js';
import { QuackFormHandler } from '../../../../app/src/rubberduck/cms/src/Form/dist/QuackFormHandler.js';
import { PropertyHandler } from '../../../../app/src/rubberduck/property/dist/js/PropertyHandler.js';
import { Pagination } from '../../../rubberduck/dist/lib/rubberduck/pagination/pagination2.build.js';
import { getTranslation, viewport } from '../../../rubberduck/dist/js/utils.js';
import Swup from 'swup';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';

require('is-in-viewport/lib/isInViewport.min.js');

var $html = $('html');
var $body = window.$body = $('body');
var $nav = $('.nav');
var $menu = $('.menu');
var $content = $('.content');
var $main = $('#main');
var debug = $html.hasClass('debug');
var bgSetter = null;
var maps = [];
var lang = $html.attr('lang');
var swup;
var $swup_status = $('.swup-status');
var last_scroll_pos = $(window).scrollTop();
var $pagination;
var history_timeout;
let propertyHandler;

const lazyLoader = new LazyLoad();
lazyLoader.default();

// SWUP
if (!isIE()) {
    if (swup == undefined) {
        let containers = ['#main', '#recaptcha_script', '.top__lang'];
        let swup_containers = []
        for (let i = 0; i < containers.length; i++) {
            const e = containers[i];
            if ($(e).length > 0) swup_containers.push(e);
        }
        var ga_measurement_id = null;
        if (google_credentials.analytics.measurement_id !== "") {
            ga_measurement_id = google_credentials.analytics.measurement_id;
        }
        var swup_plugins = [
            new SwupScriptsPlugin({
                head: false,
                body: true,
            }),
            new SwupHeadPlugin()
        ];
        if (google_credentials.analytics.active) {
            swup_plugins.push(
                new SwupGaPlugin({
                    gaMeasurementId: ga_measurement_id
                })
            );
        }
        if (google_credentials.tag_manager.active) {
            swup_plugins.push(new SwupGtmPlugin());
        }
        swup = new Swup({
            containers: swup_containers,
            cache: false,
            linkSelector: 'a[href^="' +
                window.location.origin +
                '"]:not([data-no-swup]):not(.no-swup):not([target="_blank"]):not([href^="tel:"]):not([href^="mailto:"]):not([data-fancybox]):not([class^="ui-"])',
            animateHistoryBrowsing: true,
            plugins: swup_plugins
        });

        // Swup events
        swup.hooks.on('animation:out:start', reset);
		swup.hooks.on('animation:out:end', destroy);
		swup.hooks.on('content:replace', onLoad);
        swup.hooks.on('link:self', function () {
            if (!$body.hasClass('menu--shown')) {
                scrollPage('#main');
            } else {
                toggleBurgerMenu();
            }
        });

        document.getElementById('google_credentials').remove();
    }
} else {
    $('.popup[data-popup="update-browser"]').fadeIn(1000);
    $html.removeClass('is-animating');
}
// Fade out content on page refresh
window.onbeforeunload = function (e) {
    if (
        typeof e.target.activeElement.href === 'undefined' ||
        e.target.activeElement.href.indexOf('tel:') == -1 &&
        e.target.activeElement.href.indexOf('mailto:') == -1
    ) {
        clearTimeout(history_timeout);
        // Only when it is not a phone or mail link
        $html.addClass('is-animating');
        reset();
    }
}
function swupStatusChange(string) {
    $swup_status.fadeOut(125, function () {
        $swup_status.html(string).fadeIn(125);
    });
}

function onLoad() {
    swupStatusChange('Quack quack!');
    $content = $('.content');
    $main = $('#main');

    $('#main > .content .section:not(.fullBG):not(.fullBGfix)').each(function(index, section) {
        if ($(section).css('background-color') == $(section).next('.section:not(.fullBG):not(.fullBGfix)').css('background-color')) {
            $(section).next('.section:not(.fullBG):not(.fullBGfix)').find('> .padd').addClass('padd--bottom');
        }
    });

    // Google map on page reentry
    if (typeof initMap !== 'undefined') initMaps();

    // Landing page after swup
    if ($main.hasClass('is-landing-page')) $body.addClass('is-landing-page');
    // Topless nav after swup
    if ($main.hasClass('topless')) $body.addClass('topless');

    // MENU AUTO ACTIVE STATE
    let currentURL = window.location.href;
    let $nav_links = $('a', $nav);
    let $menu_links = $('a', $menu);
    let $footer_links = $('a', $('footer'));
    let $all_links = $nav_links.add($menu_links).add($footer_links);

    // Nav and menu links
    for (let i = 0; i < $all_links.length; i++) {
        const $el = $all_links.eq(i).removeClass('active');
        if (currentURL == $el.attr('href')) {
            setTimeout(function () {
                $el.addClass('active');
            }, 10)
        }
    }

    $body.on('click', 'video', function () {
        // $(this).parent().toggleClass('active');
        togglePlayMedia(this);
    });

    ///////////////////////////////////////////////////////////////////////////
    // FORMS DATEPICKERS
    ///////////////////////////////////////////////////////////////////////////
    $('.form_datepicker').datepicker({
        beforeShow: function (input, inst) {
            var classArr = $(input).closest('.section').attr('class').split(/\s+/);
            $.each(classArr, function(index, value){
                if (value.startsWith('RM')) inst.dpDiv.addClass(value + '-ui-datepicker');
            });
        }
    });

    ///////////////////////////////////////////////////////////////////////////
    // SELECT2
    ///////////////////////////////////////////////////////////////////////////
    let select2_options = {
        debug: true,
        width: '100%',
        minimumResultsForSearch: Infinity,  // Hide the search input
        theme: '',
        language: lang
    }
    $selects = $('select');

    for (let i = 0; i < $selects.length; i++) {
        let $el = $selects.eq(i);
        select2_options.dropdownParent = $el.parent();
        $el.select2(select2_options)
            .on('select2:open', function (e) {
                // Search
                $('.select2-search__field').attr('placeholder', (lang == 'fr' ? 'Recherche' : 'Search'));

                let $dropdown = $('.select2-dropdown');
                $dropdown.hide();
                setTimeout(function () { $dropdown.slideDown(250); }, 10);
            });
    }

    $file_inputs = $('.input--file input[type="file"]');
    $file_inputs.on('change', function () {
        let $this = $(this);
        let $display = $this.next();

        if ($this.val() != '') {
            $display.addClass('not-empty');
            $display.children('.input__path').clearQueue().stop().fadeOut(250);
            setTimeout(function () {
                $display.children('.input__path').html($this.val().replace('C:\\fakepath\\', '')).fadeIn(250);
            }, 250);
        } else {
            $display.removeClass('not-empty');
            $display.children('.input__path').clearQueue().stop().fadeOut(250);
            setTimeout(function () {
                $display.children('.input__path').html($this.attr('placeholder')).fadeIn(250);
            }, 250);
        }
    });
    $file_inputs.next().find('.input__clear').on('click', function () {
        $(this).closest('.form__input').find('input').val('').trigger('change');

        return false;
    });

    $body.on('click', '.redBox .close_wrapper', function () {
        $(this).closest('.redBox').slideUp(function () {
            $(this).remove();
        });
    });

    let form_handler = new QuackFormHandler({
        ajax_selector: 'form:not(.no_ajax):not(.custom_ajax):not(.filter_container)',
        no_ajax_selector: 'form.no_ajax'
    });

    $body.on('click', '.clear-form', function () {
        clearForm($(this).closest('form').parent());
    });


    // Video controls Mourad
    $body.on('click', '.video__play', function () {
        let video = $(this).parent().siblings('video')[0];
        if (!video) return;

        togglePlayMedia(video);
    });
    $body.on('click', '.video__volume', function () {
        let video = $(this).parent().siblings('video')[0];
        if (!video) return;

        toggleSoundMedia(video);
    });

    // Video button set states
    let videos = document.getElementsByTagName('video');
    Array.from(videos).forEach((video) => {
        video.load();
        if (
            !Boolean(video.mozHasAudio) &&
            !Boolean(video.webkitAudioDecodedByteCount) &&
            !Boolean(video.audioTracks && video.audioTracks.length)
        ) {
            let videoSoundControl = video.parentElement.querySelector('.video__volume');
            if (videoSoundControl != null) videoSoundControl.classList.add('hide');
        }

        // add active classes on load for videos that aren't autoplay
        if (video.autoplay !== true && video.paused) {
            video.classList.add('active');
            if (video.parentElement == null) return;
            let play = video.parentElement.querySelector('.video__play');
            if (play == null) return;
            play.classList.add('active');
        }

        video.addEventListener('play', () => {
            if (video.parentElement == null) return;
            let play = video.parentElement.querySelector('.video__play');
            if (play == null) return;
            play.classList.remove('active');
        });

        video.addEventListener('pause', () => {
            video.classList.add('active');
            if (video.parentElement == null) return;
            let play = video.parentElement.querySelector('.video__play');
            if (play == null) return;
            play.classList.add('active');

        });
        video.addEventListener('ended', () => {
            video.classList.add('active');
            if (video.parentElement == null) return;
            let play = video.parentElement.querySelector('.video__play');
            if (play == null) return;
            play.classList.add('active');
        });

        video.addEventListener('volumechange', () => {
            if (video.parentElement == null) return;
            let volume = video.parentElement.querySelector('.video__volume');
            if (volume == null) return;
            if (video.muted || video.volume == 0) {
                volume.classList.remove('active');
                return;
            }
            volume.classList.add('active');
        });

        video.addEventListener('loadeddata', () => {
            let videoSoundControl = video.parentElement.querySelector('.video__volume');
            if (videoSoundControl == null) return;
            if (
                !Boolean(video.mozHasAudio) &&
                !Boolean(video.webkitAudioDecodedByteCount) &&
                !Boolean(video.audioTracks && video.audioTracks.length)
            ) {
                videoSoundControl.classList.add('hide');
                return;
            }
            videoSoundControl.classList.remove('hide');
        });

    });

    ///////////////////////////////////////////////////////////////////////////
    // SLICK
    ///////////////////////////////////////////////////////////////////////////
    if ($('.slick--RGO07').length) {
        // Image glitch fix
        $('.slick--RGO07').each(function () {
            let RGO07_slides = $(this).children('.slide').length;
            let slides_to_show = 3;
            if (RGO07_slides <= 3) {
                slides_to_show = RGO07_slides;
                $(this).addClass('no-offset slides--' + slides_to_show);
            }

            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: slides_to_show,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: false,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                // waitForAnimate: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ],
                rows: 0
            });
        });
    }

    /* -- SLICK -- */
    if ($('.slick__articles').length) {
        $('.slick__articles').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 901,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            rows: 0
        });
    }
    if ($('.slick_full_width').length) {
        $('.slick_full_width').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: true,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            rows: 0
        });
    }
    /*
    if ($('.slick--gallery').length) {
        $('.slick--gallery').each(function () {
            // let gallery_slides = $(this).children('.slide').length;
            // let slides_to_show = gallery_slides;
            // if (gallery_slides >= 3) {
            //     slides_to_show = 3;
            //     $(this).addClass('slides--3');
            // }
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                rows: 0
            });
        })
    }
*/



    if ($('.slick--gallery:not(.slick--gallery-configurable)').length) {

        $('.slick--gallery:not(.slick--gallery-configurable)').each(function () {       
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: true,
                centerMode: true,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                rows: 0
        })
    
        });
    }


    if ($('.slick--gallery.slick--gallery-configurable').length) {
    $('.slick--gallery.slick--gallery-configurable').each(function () {
        const $slider = $(this);

        if ($slider.hasClass('slick-initialized')) return;

        let interval = $slider.data('interval');
        let autoplay = !!interval && interval > 0;
        let transitionSpeed = 1000;
        let autoplaySpeed = autoplay ? (interval + transitionSpeed) : 1000;


        $slider.slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: transitionSpeed,
            fade: true,
            centerMode: false,
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: true,
            rows: 0

        });

    });
    }

    if ($('.slick--RMO03, .slick--RMO06, .slick--RMO07, .slick--RMO08').length) {
        $('.slick--RMO03, .slick--RMO06, .slick--RMO07, .slick--RMO08').each(function () {
            let slides = $(this).children('.slide').length;
            let slides_to_show = slides;
            if (slides >= 3) {
                slides_to_show = 3;
                $(this).addClass('slides--3');
            }

            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: slides_to_show,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: (slides_to_show < 2 ? 1 : 2)
                        }
                    },
                    {
                        breakpoint: 601,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ],
                rows: 0
            });
        });
    }
    if ($('.slick--RMO19').length) {
        $('.slick--RMO19').each(function () {
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 3000,
                slidesToShow: 5,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                responsive: [
                    {
                        breakpoint: 1441,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 601,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 374,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ],
                rows: 0
            });
        });
    }
    if ($('.slick--RMO13').length) {
        $('.slick--RMO13').each(function () {
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                adaptiveHeight: true,
                rows: 0
            });
        });
    }
    if ($('.slick--RMO02').length) {
        $('.slick--RMO02').each(function () {
            let slides = $(this).children().length;
            let slides_to_show = slides;
            if (slides >= 5) {
                slides_to_show = 5;
                $(this).addClass('slides--5');
            }

            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: slides_to_show,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                responsive: [
                    {
                        breakpoint: 1401,
                        settings: {
                            slidesToShow: (slides_to_show < 4 ? slides_to_show : 4)
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: (slides_to_show < 3 ? slides_to_show : 3)
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: (slides_to_show < 2 ? slides_to_show : 2)
                        }
                    },
                    {
                        breakpoint: 481,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ],
                rows: 0
            });
        });
    }
    // RMF08
    if ($('.RMF08__main_slider').length) {
        $('.RMF08__main_slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 750,
            fade: true,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            adaptiveHeight: true,
            asNavFor: '.RMF08__thumbnails_slider',
            rows: 0
        });
        $('.RMF08__thumbnails_slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            vertical: true,
            verticalSwiping: true,
            speed: 750,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 2,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            waitForAnimate: false,
            focusOnSelect: true,
            //draggable: true,
            swipe: true,
            //swipeToSlide: true,
            asNavFor: '.RMF08__main_slider',
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 4,
                        vertical: false,
                        verticalSwiping: false,
                        draggable: true,
                        swipeToSlide: true
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 3,
                        vertical: false,
                        verticalSwiping: false,
                        draggable: true,
                        swipeToSlide: true
                    }
                }
            ],
            rows: 0
        });
    }
    //RMO10
    if ($('.slick--RMO10').length) {
        $('.slick--RMO10').each(function () {
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 3,
                slidesToScroll: 3,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 551,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 2
                        }
                    }
                ],
                rows: 0
            });
        });
    }
    if ($('.slick--RGO21').length) {
        $('.slick--RGO21').each(function () {
            $(this).slick({
                dots: true,
                arrows: false,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                adaptiveHeight: true,
                rows: 0
            });
        });
    }

    if (typeof backgroundSetter === "function") {
        bgSetter = new backgroundSetter();
        bgSetter.init();
    }


    ///////////////////////////////////////////////////////////////////////////
    // VIDEO RGO08
    ///////////////////////////////////////////////////////////////////////////
    // if($('.RGO08').length){
    //     $('body').on('click', '.RGO08 .play-btn', function(){
    //        $(this).prev('video').trigger('play');
    //        $(this).fadeOut();
    //     });
    //     $('body').on('click', '.RGO08 video', function(){
    //        $(this).trigger('pause');
    //        $('.RGO08 .play-btn').fadeIn();
    //     });
    // }


    $body.on('click', '.page-scroll', function () {
        var targetDiv = $(this).attr('href') || $(this).data('target');
        // if (targetDiv) targetDiv = $(this).data('target');

        scrollPage(targetDiv);

        return false;
    });

    ///////////////////////////////////////////////////////////////////////////
    // ICEBERG
    ///////////////////////////////////////////////////////////////////////////
    $body.on('click', '.iceberg__head a', function (e) {
        e.stopPropagation();
    });
    $body.on('click', '.iceberg__head', function (e) {
        let $this = $(this);
        // Slide toggle clicked iceberg
        $this.toggleClass('active')
            .next('.iceberg__body').stop().slideToggle(500);
    });
    $('.iceberg__head.active').next().show();

    ///////////////////////////////////////////////////////////////////////////
    // SHOP
    ///////////////////////////////////////////////////////////////////////////
    function updatePagination(data) {
        if (data.additional_html) {
            if (data.additional_html.tags) {
                let html = '';
                html = data.additional_html.tags;
                if ($('#tags').length) {
                    $('#tags').html(html);
                    $('#tags .iceberg__head.active').next().show();
                }
            }
            if (data.additional_html.info_windows) {
                if (typeof propertyHandler != 'undefined') {
                    propertyHandler.setMapData(data.additional_html.info_windows);
                }
            }
        }
    }
    window['updatePagination'] = updatePagination;

    $body.on('change', '.filter_sub [type="checkbox"], .filter_sub [type="radio"]', function (e) {
        let filter = true;
        let container = $(this).closest('.filter_container');
        container.find('input:not(:checked)').parents('li').removeClass('active');
        // Filters default "View all"
        if ($(this).val() == '') {
            container.find('input').prop('checked', false);
            container.find('.active').removeClass('active');
            $(this).parents('li').addClass('active');
        } else {
            if ($(this).prop('checked')) {
                $(this).parents('li').addClass('active');
                if ($(this).hasClass('view_all')) {
                    $(this).closest('li').siblings().removeClass('active').find('input').prop('checked', false);
                } else {
                    $(this).closest('ul').find('input.view_all').prop('checked', false).closest('li').removeClass('active');
                }
            } else {
                $(this).parents('li').removeClass('active');
                if ($('[name="' + $(this).attr('name') + '"]:checked').length == 0) {
                    container.find('.filter_sub label').first().trigger('click');
                    filter = false;
                }
            }
        }
        if (filter) {
            filterPagination();
        }
    });

    $body.on('keypress', '.filter_sub [type="search"]', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            filterPagination();
        }
    });

    $body.on('change', '.filter_sub select:not(.no_trigger)', function (e) {
        filterPagination();
    });

    $body.on('click', '.trigger_filters', function (e) {
        e.preventDefault();
        filterPagination();
    });

    $body.on('click', '.reset_filters', function (e) {
        e.preventDefault();
        let container = $(this).closest('.filter_container');
        // Uncheck all
        container.find('.filter_sub [type="checkbox"], .filter_sub [type="radio"]').prop('checked', false).parents('li.active').removeClass('active');
        container.find('.filter_sub select').addClass('no_trigger').val('').trigger('change').removeClass('no_trigger');
        container.find('.filter_sub [type="text"], .filter_sub [type="search"]').val('');
        // Check "View All"
        container.find('.filter-iceberg .filter_container > ul > .filter_sub:first-child').addClass('active');
        let slider = container.find('.price-slider');
        if (slider.length) {
            let slider_option = slider.slider('option');
            slider.addClass('disable').slider('values', [slider_option.min, slider_option.max]).removeClass('disable').trigger('slide', [{ values: [slider_option.min, slider_option.max] }]);
        }
        filterPagination();
    });

    ///////////////////////////////////////////////////////////////////////////
    // MIXITUP
    ///////////////////////////////////////////////////////////////////////////
    if ($('.mixitup').length) {
        if ($('.filtered:not(.pagination_content_wrapper)').length > 0) {
            var mixitup = require('mixitup');
            var mixitupMultifilter = require('../lib/mixitup/mixitup-multifilter.min.cjs');
            mixitup.use(mixitupMultifilter);
            var mixit = mixitup('.filtered:not(.pagination_content_wrapper)', {
                selectors: {
                    target: '.filtered_items',
                    control: '.mixitup li'
                },
                multifilter: {
                    enable: true
                },
                callbacks: {
                    onMixEnd: function(state) {
                        $(window).trigger('scroll');
                    },
                    onMixClick: function(state, originalEvent) {
                        let section = $(state.container).closest('.section');
                        section.find('.mixitup .filter_container .searchbar input').val('');
                        section.find('.mixitup .filter_container .select_wrapper.show select').val('all').trigger('change.select2');
                    }
                }
            });
            const delay = (function(){
                var timer = 0;
                return function(callback, ms){
                    clearTimeout (timer);
                    timer = setTimeout(callback, ms);
                }
            })();
            var mixitupContainer, mixitupItems, mixitupSearchInputText;
            $body.on('input', '.mixitup.filters .filter_container .searchbar input', function() {
                mixitupSearchInputText = $(this).val().toLowerCase();
                mixitupContainer = $(this).closest('.section');
                mixitupItems = mixitupContainer.find('.filtered .filtered_items');
                // Delay function invoked to make sure user stopped typing
                delay(function(){
                    // Reset category to 'all'
                    let filter = mixitupContainer.find('.desktop_filters [data-filter].mixitup-control-active');
                    if (filter.length) {
                        filter.removeClass('mixitup-control-active');
                        filter.find('input').prop('checked', false);
                        mixitupContainer.find('.desktop_filters [data-filter="all"]').addClass('mixitup-control-active').find('input').prop('checked', true);
                    }
                    var matching = $();
                    // Check to see if input field is empty
                    if ((mixitupSearchInputText.length) > 0) {            
                        mixitupItems.each(function() {
                            // add item to be filtered out if input text matches items inside the title   
                            if ($(this).text().toLowerCase().match(mixitupSearchInputText)) {
                                matching = matching.add(this);
                            } else {
                                // removes any previously matched item
                                matching = matching.not(this);
                            }
                        });
                        mixit.filter(matching);
                    } else {
                        // resets the filter to show all item if input is empty
                        mixit.filter('all');
                    }
                }, 200);
            });
        }
        let prevent_change = false;
        // ON SELECT CHANGE
        $body.on('change', '.select_filters', function (e) {
            if (prevent_change === true) {
                prevent_change = false;
                return false;
            }
            let val = $(this).val();
            let radios = $(this).closest('.select_wrapper').next('.desktop_filters').find('li');
            if (radios.length > 0) {
                // Select for mobile categories
                radios.each(function () {
                    let radio = $(this).find('input[type="radio"]').first();
                    if (radio.val() == val) {
                        radio.closest('li')[0].click();
                    }
                });
            } else {
                // Tags
                let filter = (val != 'all' ? val : '');
                let categ = $(this).closest('.filter_container').find('.desktop_filters li input:checked');
                if (categ.val() != 'all' && categ.val() != undefined) filter += categ.val();
                if (filter == '') filter = 'all';
                mixit.filter(filter).then(function (state) {
                    categ.closest('li').addClass('mixitup-control-active');
                });
            }
        });
    }

    $body.on('change', '.desktop_filters li input[type="radio"]', function(e) {
        $('.desktop_filters li.active').removeClass('active');
        if ($(this).prop('checked') == true) {
            $(this).closest('li').addClass('active');
        } else {
            $(this).closest('li').removeClass('active');
        }
    });

    // Filters sidebar
    $body.on('click', '.open-filters', function () {
        $body.addClass('filters--shown');
    });
    $body.on('click', '.close-filters', function () {
        $body.removeClass('filters--shown');
    });

    ///////////////////////////////////////////////////////////////////////////
    // CALENDAR
    ///////////////////////////////////////////////////////////////////////////

    calendar_handler = new EventCalendarHandler();
    calendar_handler.init();

    $body.on('click', '.dropdown__drop li', function () {
        let sort = $(this).attr('data-sort');
        let label = $(this).text();

        let filter = $(this).closest('.dropdown').find('.dropdown__current');
        filter.find('.label .value').text(label);
        filter.find('input').val(sort);

        filterPagination();
    });

    // GDPR
    if (typeof GDPRHandler != 'undefined') {
        let gdpr = new GDPRHandler();
        gdpr.init();
    }

    // PROPERTY
    if (typeof PropertyHandler != 'undefined') {
        propertyHandler = new PropertyHandler();
    }

    ///////////////////////////////////////////////////////////////////////////
    // COPY URL
    ///////////////////////////////////////////////////////////////////////////
    $('.copy_url')
        .mousedown(function () { $(this).addClass('mouseDown'); })
        .mouseup(function () { $(this).removeClass('mouseDown'); })
        ;

    $body.on('click', '.copy_url', function () {
        var dummy = document.createElement('input'),
            text = window.location.href;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        $('.link_copied').slideDown().delay(1000).slideUp();
    });

    ///////////////////////////////////////////////////////////////////////////
    // PAGINATION
    ///////////////////////////////////////////////////////////////////////////
    if ($('.pagination_wrapper').length > 0) {
        let number_per_page = 24;
        let current_page = 1;
        let params = window.location.search.substr(1).split('&');
        if (params.length > 0) {
            for (let i = 0; i < params.length; i++) {
                let pair = params[i].split('=');
                let key = pair[0];
                if (key == 'number_items') {
                    number_per_page = parseInt(pair[1]);
                }
                if (key == 'page') {
                    current_page = parseInt(pair[1]);
                }
            }
        }
        $pagination = new Pagination({
            display_go_to: false,
            size_list: 'mini',
            number_items_per_page: number_per_page,
            call_back_return: 'updatePagination'
        });

        $pagination.currentPage = current_page;

        filterPagination();
    }

    $body.on('keypress', 'input[type="number"]', function (e) {
        if (e.keyCode > 31 && (e.keyCode < 48 || e.keyCode > 57)) {
            e.preventDefault();
        }
    });

    // Close popup popup
    $body.on('click', '.RGO16__close, .GDPR__close', closePopup);


    // RGO18
    $('.close-RGO18').click(function () {
        $(this).closest('.RGO18').slideUp(250);

        setTimeout(() => {
            $(this).closest('.RGO18').remove();
        }, 250);
    })

    // '####:'##::::'##:'##::::'##::'#######::'########::'####:'##:::::::'####:'########:'########::
    // . ##:: ###::'###: ###::'###:'##.... ##: ##.... ##:. ##:: ##:::::::. ##:: ##.....:: ##.... ##:
    // : ##:: ####'####: ####'####: ##:::: ##: ##:::: ##:: ##:: ##:::::::: ##:: ##::::::: ##:::: ##:
    // : ##:: ## ### ##: ## ### ##: ##:::: ##: ########::: ##:: ##:::::::: ##:: ######::: ########::
    // : ##:: ##. #: ##: ##. #: ##: ##:::: ##: ##.... ##:: ##:: ##:::::::: ##:: ##...:::: ##.. ##:::
    // : ##:: ##:.:: ##: ##:.:: ##: ##:::: ##: ##:::: ##:: ##:: ##:::::::: ##:: ##::::::: ##::. ##::
    // '####: ##:::: ##: ##:::: ##:. #######:: ########::'####: ########:'####: ########: ##:::. ##:
    // ....::..:::::..::..:::::..:::.......:::........:::....::........::....::........::..:::::..::
    ///////////////////////////////////////////////
    // PROPERTIES MAP
    ///////////////////////////////////////////////    
    if ($('.RMO14').length) {
        $('.RMO14__filters--display .displays').on('click', function () {
            $('.RMO14 .displays').removeClass('active');
            $(this).addClass('active');

            if ($('.grid-display').hasClass('active')) {
                $('.RMO14__map').css('display', 'none');
                $('.RMO14__grid').css('display', 'flex');
            } else {
                $('.RMO14__map').css('display', 'block');
                $('.RMO14__grid').css('display', 'none');
            }
        })
    }
    if ($('.RMF08').length) {
        $('.RMF08__specs-element').on('click', function () {
            $('.RMF08__specs-element.active').removeClass('active');
            $(this).addClass('active');
            let data_menu = $(this).data('menu');
            // show matching content
            $('.RMF08__content').each(function () {
                if ($(this).data('menu') == data_menu) {
                    $(this).slideDown();
                } else {
                    $(this).slideUp();
                }
            })
        })
        $('.RMF08__specs--menu select').on('change', function () {
            let value = $(this).val();
            $('.RMF08__content').each(function () {
                if ($(this).data('menu') == value) {
                    $(this).slideDown();
                } else {
                    $(this).slideUp();
                }
            })
        })
        // MENU CALCULATE BTN CLICK
        $('.RMF08_calculator-btn').on('click', function () {
            $('.RMF08_calculator').addClass('appear');
            $body.addClass('no-scroll');
        })
        $('.RMF08_calculator .close').on('click', function () {
            $('.RMF08_calculator').removeClass('appear');
            $body.removeClass('no-scroll');
        })
        // CALCULATOR RESULT
        $('#calc_mortgage_payment').on('click', function (e) {
            let $form = $(this).parents('form').first();
            let payment = propertyHandler.calcMortgage($form);
            let formatted_payment = payment + '$ / ' + $form.find('[name="payment_frequency"] option:selected').text();
            $('#insert_result_here').text(formatted_payment);
        });
        $('.RMF08_calculator .reset').on('click', function () {
            $('#insert_result_here').text($('.original_text').text())
        })
        ///////////////////////////////////////////////
        // TXX-CALCULATOR QUANTITY BUTTONS
        ///////////////////////////////////////////////
        $('.quantity .plus').on('click', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let inputVal = input.val();
            var plus = '';

            if (isNaN(inputVal) || input.val() == "") {
                plus = 0 + 1;
            } else {
                plus = parseInt(inputVal) + 1;
            }
            input.val(plus);

        })
        $('.quantity .minus').on('click', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let minus = parseInt(input.val()) - 1;
            if (minus >= 0) {
                input.val(minus);
            } else {
                input.val(0);
            }
        })
    }


    $(window).trigger('resize');
    $(window).trigger('scroll');

    setTimeout(function () {
        $(window).trigger('resize');
        $(window).trigger('scroll');
    }, 500)

} // onLoad()
function reset() {
    swupStatusChange(getTranslation('cms_general', 'loading_page'));
    // Remove event listeners
    $content.off();
    // Reset menu state
    $body.off().removeClass();
} // reset()
function destroy() {
    window.scrollTo(0, 0);

    // Destroy selectrics
    // $('select.selectric').selectric('destroy');
    // Destroy select2
    $('select').select2('destroy');
    // Destroy slicks
    $('.slick-initialized').slick('unslick');
    // Destroy Isotope
    // $('.isotope-initialized').isotope('destroy');
    // Destroy maps
    if (maps.length > 0) {
        for (let i = 0; i < maps.length; i++) {
            maps[i].remove();
        }
        maps = [];
    };
} // destroy()


// OUTSIDE SWUP ////////////////////////////////////////////////////////////////

// BURGER MENU
$('.hamburger').on('click', toggleBurgerMenu);

function toggleBurgerMenu() {
    $body.toggleClass('menu--shown');
    $body.toggleClass('no-scroll');
    $menu.find('.menu__dropdown.active').removeClass('active');
    $menu.find('.scroll').animate({
        scrollTop: 0
    });
    // Reset menu subs
    $('.menu__dropdown + ul', $menu).clearQueue().stop().slideUp(250);
}

$menu_subs = $('.menu__dropdown', $menu);
$menu_subs.on('click', function () {
    let $this = $(this);
    $this.parent().siblings().removeClass('active').siblings('ul').clearQueue().stop().slideUp(400);
    $this.toggleClass('active').siblings('ul').clearQueue().stop().slideToggle(400);
});


// RGO16
function closePopup() {
    let $this = $(this);
    let $popup = $this.closest('.popup');

    $popup.fadeOut(500, function () {
        $(this).remove();
    });
}

// Form submit
$body.on('click', '.submit-form', submitForm);

///////////////////////////////// Mourad ///////////////////////////////////////////////


function togglePlayMedia(media) {
    if (!media) return;
    if (media.paused) {
        media.play();
    } else {
        media.pause();
    }
}

function toggleSoundMedia(media) {
    if (!media) return;

    if (media.muted) {
        media.muted = false;
    } else {
        media.muted = true;
    }
}

function giveSizeToOthers($context, $toResize, minWidth, maxWidth) {
    if ($context.length > 0) {
        if ($toResize.length > 0) {
            if (!minWidth) var minWidth = 0;  	// compatibilité IE
            if (!maxWidth) var maxWidth = 9999;  	// compatibilité IE
            if (viewport().width > minWidth && viewport().width < maxWidth) {
                $context.each(function () {
                    var height = 0;
                    var $objects = $(this).find('.' + $toResize.attr("class").split(' ')[0]);
                    $objects.each(function () {
                        $objects.height('');
                        var currentHeight = $(this).children('.resize').outerHeight();

                        if (currentHeight > height) height = currentHeight;
                    });
                    $objects.children('.resize').parent().height(height);
                });
            }
            else {
                $toResize.height('');
            }
        } else if ($context.length > 0) {
            // console.log('"$toResize == undefined" dans giveSizeToOthers : '+$toResize.selector);
        }
    }
}

function handleResetFiltersVisiblity() {
    $('.reset_filters').each(function() {
        let hide = true;
        let btn = $(this);
        let inputs = btn.closest('form').find('input:not([type="hidden"]), select');
        inputs.each(function(index, input) {
            if (hide) hide = ($(input).val() == '');
            if (index == (inputs.length - 1)) btn.toggleClass('hide_reset', hide);
        });
    });
}
function filterPagination() {
    if ($('.pagination_wrapper').length > 0) {
        if ($pagination.htmlWrapper.length > 0 && $pagination.htmlContentWrapper.length > 0) {
            $pagination.fetchAjaxInformationPagination(
                false,
                true,
                false
            );
            handleResetFiltersVisiblity();
        }
    }
}

/**
 * @author Maxime Doré
 * @param string targetDiv	le hash vers lequel scroller la page (ex : "#content")
 * @param number offset		le offsetTop soustrait au scrollTop (ex : 100 scroll 100px plus haut)
 */
function scrollPage(targetDiv, offset) {
    if (!offset) var offset = 120;

    if (!$body.hasClass('no-scroll') && $(targetDiv).length > 0) {
        $('html, body').clearQueue().stop().animate({
            scrollTop: $(targetDiv).offset().top - offset
        }, 750);
    }
}

// Detect IE
function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {    // If Internet Explorer, return version number
        return true;
    }

    return false;
}

// Submit current form for inline onclick
function submitForm() {
    $(this).closest('form').submit();
}

// Clear all form inputs
function clearForm($container) {
    // Inputs and textareas
    $('input:not([type="submit"]):not([type="hidden"]), textarea', $container).val('').prop('checked', false).trigger('change');
    // Selects
    $('select', $container).val('').trigger('change');
    // Quantity input reset to minimum
    $('.quantity-input input').val($('.quantity-input input').attr('min'));
}

function goBack(prev_url) {
    if (window.history.length > 1) {
        // Use history to change page
        window.history.go(-1);
    }
    if (!isIE()) {
        history_timeout = setTimeout(function () {
            //  Use previous URL as a fallback
            swup.loadPage({
                url: prev_url
            });
        }, 100)
    } else {
        // IE fallback
        window.location = prev_url;
    }
}
window.addEventListener('popstate', function (e) {
    // Prevent the history fallback from triggering
    clearTimeout(history_timeout);
});

// Resize Fn
function onResize() {
    giveSizeToOthers($('.row--0'), $('.resized'), 0);
    giveSizeToOthers($('.row--600'), $('.resized'), 600);
    giveSizeToOthers($('.row--768'), $('.resized'), 768);
    giveSizeToOthers($('.row--900'), $('.resized'), 900);
    giveSizeToOthers($('.row--1024'), $('.resized'), 1024);
    giveSizeToOthers($('.slick--RGO07'), $('.text'), 600);
    giveSizeToOthers($('.cards__wrap .cards__item'), $('.text'), 1024);
    giveSizeToOthers($('.RMO18 a'), $('.text'), 1024);
    giveSizeToOthers($('.RMO03 .slick--RMO03'), $('.text .h3'), 600);
}
// Scroll Fn
function onScroll(e, posTop) {
    if (!$html.hasClass('is-animating')) {
        if (!posTop) posTop = $(window).scrollTop();

        if (posTop > 50) {
            $body.addClass('scroll');
        } else {
            $body.removeClass('scroll');
        }
        if (posTop > last_scroll_pos) {
            $body.addClass('going-down');
        } else {
            $body.removeClass('going-down');
        }
        last_scroll_pos = posTop;

        // isInViewport for scroll animations and video autoplay
        $('.visible').each(function () {
            var $this = $(this);

            if ($this.is(':in-viewport()')) {
                $this.addClass('alive');
                if ($this.find('video[autoplay], video.active').length) {
                    $this.find('video[autoplay], video.active')[0].play();
                }
            } else if (!$this.hasClass('once')) {
                $this.removeClass('alive done');
                if ($this.find('video[autoplay], video.active').length) {
                    $this.find('video[autoplay], video.active')[0].pause();
                }
            }
        });
        // isInViewport for slick autoplay
        $('.slick-initialized').each(function () {
            var $this = $(this);

            if ($this.is(':in-viewport()')) {
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {
                    $this.slick('slickPlay');
                }
            } else if (!$this.hasClass('once')) {
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {
                    $this.slick('slickPause');
                }
            }
        });
    }
}

$(window).on('resize', $.throttle(100, onResize));
$(window).on('scroll', $.throttle(100, onScroll));
$(window).on('load', function () {
    $(window).trigger('resize');
    $(window).trigger('scroll');

    $html.removeClass('is-animating');
    onLoad();
});
$(window).on('resetDOM', function () {
    if (typeof backgroundSetter === "function") {
        new backgroundSetter().init();
    }
    $(window).trigger('resize');
});




// RGO01-A - YouTube Iframe Mourad
///////////////////////////////////////////////////////////////////////////
(function() {
    'use strict';
    
    let ytPlayers = new Map(); 
    let ytApiLoaded = false;
    let ytApiReady = false;

  
    function initYouTubePlayers() {
        const youtubeWidgets = document.querySelectorAll('.section .yt-player');
        
        if (youtubeWidgets.length === 0) return;
        
        // Charger l'API YouTube si nécessaire
        if (!ytApiLoaded) {
            ytApiLoaded = true;
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            script.async = true;
            script.onload = () => waitForAPI(); 
            document.body.appendChild(script);
        } else {
            waitForAPI();
        }

        function waitForAPI() {
            if (typeof YT !== 'undefined' && YT.Player) {
                ytApiReady = true;
                youtubeWidgets.forEach((iframe) => {
                    if (!iframe.dataset.ytInitialized) {
                        iframe.dataset.ytInitialized = 'true';
                        
                        const player = new YT.Player(iframe, {
                            events: {
                                'onReady': () => {
                                    ytPlayers.set(iframe, player);
                                    //console.log('YouTube player ready:', iframe.id || iframe.src);
                                },
                                'onStateChange': (event) => {
                                    handleYouTubeStateChange(event, iframe);
                                }
                            }
                        });
                    }
                });
            } else {
                setTimeout(waitForAPI, 100);
            }
        }
    }

    /**
     * Gérer les changements d'état YouTube
     */
    function handleYouTubeStateChange(event, iframe) {
        const section = iframe.closest('.section');
        if (!section) return;

        //const widgetYoutube = section.querySelector('.widget--youtube');
        const playBtn = section.querySelector('.youtube__play');

        if (event.data === 1) { // Playing
            if (playBtn) playBtn.classList.remove('active');
         //   if (playBtn) playBtn.classList.add('active');
           // if (widgetYoutube) widgetYoutube.style.opacity = '1';
        } else if (event.data === 2 || event.data === 0) { // Paused or Ended
            if (playBtn) playBtn.classList.add('active');
            //if (playBtn) playBtn.classList.remove('active');
           
        }
    }

   
    $body.on('click', '.section .youtube__play', function(e) {

        e.preventDefault();
        const section = $(this).closest('.section');
        const iframe = section.find('.yt-player')[0];

 

        if (!iframe || !ytApiReady) return;

        const player = ytPlayers.get(iframe);
        const btn = $(this);
        
        if (player && typeof player.playVideo === 'function') {
            const isPlaying= !btn.hasClass('active');
  
            if (isPlaying) {
                player.pauseVideo();

                btn.addClass('active');
               
            } else {
                player.playVideo();
                btn.removeClass('active');
            }
        }
    });

    $body.on('click', '.section .youtube__volume', function(e) {
        e.preventDefault();
        const section = $(this).closest('.section');
        const iframe = section.find('.yt-player')[0];

 

        if (!iframe || !ytApiReady) return;

        const player = ytPlayers.get(iframe);
        const btn = $(this);
        
        if (player && typeof player.mute === 'function') {
            const isMuted = !btn.hasClass('active');
       
            if (isMuted) {
                player.unMute();
                btn.addClass('active');

            } else {
                player.mute();
                btn.removeClass('active');

            }
        }
    });

    /**
     * Gestion du state change via l'API YouTube (pour synchronisation externe)
     */
    $body.on('youtube:sync', '.section .yt-player', function() {
        const iframe = this;
        const player = ytPlayers.get(iframe);
        if (!player) return;
        
        const state = player.getPlayerState();
        handleYouTubeStateChange({ data: state }, iframe);
    });

    // Initialisation au chargement du DOM
    $(document).ready(function() {
        initYouTubePlayers();
    });

    // Réinitialisation pour les chargements AJAX (SPA)
    $(window).on('resetDOM', function() {
        // Marquer tous les iframes comme non-initialisés
        document.querySelectorAll('.yt-player').forEach(iframe => {
            delete iframe.dataset.ytInitialized;
        });
        ytPlayers.clear();
        ytApiReady = false; // Forcer re-vérification de l'API
        initYouTubePlayers();
    });

    // Exposer onYouTubeIframeAPIReady globalement (requis par l'API YouTube)
    window.onYouTubeIframeAPIReady = function() {
        ytApiReady = true;
        initYouTubePlayers();
    };

})();